<template>
        <div id='mymanager'>
              <NavTop title='我的推荐人'/>
              <div class='content'>
                 <div class="left">
                      <div class="left-line1">{{uinfo.username}}</div>
                      <div class="left-line2">{{uinfo.mobile}}</div>
                      <div class="split"></div>
                      <div class="left-lastline">* 您可以向您的顾问咨询一些销售技巧取取经</div>
                 </div>
                 <div class="right">
                     <div class="right-img"><Icon class='right-imgcon' src="zhlogin"/></div>
                     <div class="right-copybtn" @click="doCopy">复制联系方式</div>
                 </div>
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import Icon from '@/components/icon'
export default {
  data(){
      return{
         uinfo:{}
      }
  },  
  name: 'mymanager',
  created(){
     this.getList()
  },
  methods:{
     getList(){
         this.$post("/user/getParentInfo",{}).then((data)=>{
            if(data.result.success){
                this.uinfo=data.result.info
            }
         })
     },
     doCopy(){
          this.$copyText(this.uinfo.mobile.toString()).then(function () {
          }, function () {
          })
          this.showShare=false
          this.$toast("复制成功")
      }
  },
  components:{
      NavTop,Icon
  }
}
</script>
<style scoped>
#mymanager{background-color:#F6F6F6;min-height: 100vh;}
.content{display: flex;background-image: linear-gradient(to right,#fff,#eee,#fff);border-radius: 0.2rem;margin: 0.8rem 0.35rem;padding: 0.4rem 0.25rem;}
.left{flex:4;display: flex;flex-flow: column nowrap;align-items: left;}
.right{flex:1;display: flex;flex-flow: column nowrap;align-items: center;}
.left-line1{color:#333;font-size:0.3rem;padding: 0.2rem;text-align: left;}
.left-line2{color:#444;font-size:0.3rem;padding: 0.2rem;text-align: left;}
.left-lastline{color:#555;font-size: 0.25rem;padding: 0.2rem;text-align: left;}
.split{width:80%;height: 1px;background-color: #666;margin-left: 0.2rem;margin-top: 0.2rem;margin-bottom: 0.2rem;}
.right-imgcon{width:1.0rem;height: 1.0rem;}
.right-copybtn{border: 1px solid #555;color:#333;border-radius: 0.1rem;margin-top: 0.2rem;}
</style>


